<template>
  <div v-show="showOverlay" class="upgrade-account-container modal-overlay">
    <div class="modal-content message">
      <div class="title">
        Whoops!  Your trial is expired.  
      </div>
      <div class="subtitle">
        Upgrade now to keep using our amazing system.
      </div>
      <div class="button" @click="gotoSubscriptionPlans()">
        Upgrade me!
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpgradeAccount',
  data() {
    return {
      showOverlay: false,
    }
  },
  methods: {
    gotoSubscriptionPlans() {
      this.$router.replace({ name: 'subscription-plans' })
    }
  },
  watch: {
    $route() {
      this.showOverlay = this.$router.currentRoute.name != 'subscription-plans'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.message {
  background-color: white;
  padding: 50px;

  .title {
    font-size: 30px;
  }

  .subtitle {
    font-size: 20px;
    margin: 50px 0px;
  }

  .button {
    background-color: $primary;
    color: white;
    border-radius: $border-radius;
    padding: 20px;
    cursor: pointer;
    transition: 0.1s all;
    font-size: 20px;

    animation: pulse;
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }
}
</style>